module.exports = __webpack_public_path__ + "static/media/europe-static-map.bde92dff.jpg";